import { CoverageList, FordProtect } from "../core/models/vehicle/ford-protect.model";
import { COUNTRY_CODE } from "@core/enums";

export const getDayOfWeek = (dayNumber: number, country: string): string => {
    const brDays = ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-Feira', 'Sábado'];
    const argDays = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'];
    return country === 'BRA' ? brDays[dayNumber] : argDays[dayNumber];

}

export const parseDateWithWeek = (date: Date, weekDay: string) => {
    let month = (date.getUTCMonth() + 1).toString();
    let day = (date.getUTCDate()).toString();
    parseInt(month, 10) < 10 ? month = `0${month}` : month;
    parseInt(day, 10) < 10 ? day = `0${day}` : day;
    return `${day}/${month}/${date.getFullYear()} (${weekDay})`
}

export const getRandomScreenVersion = () => Math.floor(Math.random() * 1000);

export const getLangByCountry = (country: string) => {
    switch(country) {
      case 'BRA':
        return 'pt-BR';
      case 'ARG':
          return 'es-AR';
      case 'CHL':
          return 'es-CL';
      case 'PER':
          return 'es-PE';
      case 'COL':
          return 'es-CO';
      case 'ECU':
          return 'es-EC';
      case 'VEN':
          return 'es-VE';
      default:
          return 'en-US';
    }
}

export const FORD_PROTECT_STATUS_ACTIVE = 'ativo';
export const FORD_PROTECT_STATUS_BLOCKED = 'bloqueado';
export const FORD_PROTECT_STATUS_CANCELED = 'cancelado';
export const FORD_PROTECT_STATUS_FINISHED = 'finalizado';
export const returnMessages = {
  OK: 'OK'
};

export const FORD_PROTECT_EXTEND_WARRANTY = '0BAS';
export const FORD_PROTECT_FORD_GO = 'FDGO';
export const FORD_PROTECT_EXTEND_WARRANTY_COVERAGE = ['ESP', 'FLSN'];
export const FORD_PROTECT_FLEET_VEHICLE = 'FLEE';
export const FORD_PROTECT_MAINTENANCE_COVERAGE = ['QCM', 'FLMT', 'TRUM', 'FLT'];
export const FORD_PROTECT_WEARING_PART_COVERAGE = ['AST'];

export const FORD_PROTECT_COVERAGE_STATUS_ACTIVE = 'ativo';
export const FORD_PROTECT_COVERAGE_STATUS_FINALIZED = 'inativo';
export const SESSION_FORD_PROTECT = 'fordProtectData';

export const isFordProtectValid = (fordProtectData: FordProtect, serviceMonths: any) => {
  if (
    fordProtectData &&
    fordProtectData.contractList &&
    fordProtectData.contractList.length > 0
  ) {
    const forpassActiveContracts = fordProtectData.contractList.filter(
      (c) =>
        c.productStatus.toLocaleLowerCase() === FORD_PROTECT_STATUS_ACTIVE &&
        c.productCode !== FORD_PROTECT_EXTEND_WARRANTY
    );
    const forpassActiveContractsFiltered = forpassActiveContracts.filter(
      (c) => c.coverageList.filter((x) => isServiceMonthInFordProtectCoverage(serviceMonths, x)).length > 0);
    return forpassActiveContractsFiltered.length > 0;
  }
  return false;
}

export const isServiceMonthInFordProtectCoverage = (servicesMonth: any, fordProtectCoverage: CoverageList ): boolean => {
  const maintenanceCoverage = FORD_PROTECT_MAINTENANCE_COVERAGE.find((x) => x === fordProtectCoverage.coverageCode);

  if (!maintenanceCoverage) {
    return false;
  }

  let finalCoverageVisits = fordProtectCoverage.coverageVisits;

  if (fordProtectCoverage.coverageStartVisit && fordProtectCoverage.coverageStartVisit > 0) {
    finalCoverageVisits = (finalCoverageVisits + fordProtectCoverage.coverageStartVisit - 1);
    return (servicesMonth &&
      servicesMonth >= fordProtectCoverage.coverageStartVisit * 12 &&
      servicesMonth <= finalCoverageVisits * 12 &&
      fordProtectCoverage.coverageVisits !==
      fordProtectCoverage.coverageVisitsDone &&
      fordProtectCoverage.coverageStatus.toLocaleLowerCase() ===
      FORD_PROTECT_COVERAGE_STATUS_ACTIVE);
  }

  return (servicesMonth &&
    servicesMonth <= finalCoverageVisits * 12 &&
    fordProtectCoverage.coverageVisits !==
    fordProtectCoverage.coverageVisitsDone &&
    fordProtectCoverage.coverageStatus.toLocaleLowerCase() ===
    FORD_PROTECT_COVERAGE_STATUS_ACTIVE);
}

const getCorrectedDate = (date: string) => {
  const dateFromServer = new Date(date);
  dateFromServer.setMinutes(dateFromServer.getMinutes() + dateFromServer.getTimezoneOffset());
  return dateFromServer;
}

export const getFormattedDate = (date: string) => {
  const correctedDate = getCorrectedDate(date);
  const day = correctedDate.getDate().toString().padStart(2, '0');
  const month = (correctedDate.getMonth() + 1).toString().padStart(2, '0');
  const year = correctedDate.getFullYear();
  return `${day}/${month}/${year}`;
}

export const getWeekday = (date: string): string => {
  const correctedDate = getCorrectedDate(date);
  return correctedDate.getDay().toString();
}

export const formatTime = (time: number) => {
    let key = "";
    if (time > -1) {
      const timePadded = String(time).padStart(4, '0');
      key = timePadded.substring(0, 2) + ':' + timePadded.substring(2, 4);
    }
    return key;
  }

export const isArgentina = (country: string) => COUNTRY_CODE.ARGENTINA === country;
